// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 502 ? "d2c86127" : chunkId) + "." + {"502":"396d1e499945793c","771":"724cd44531bf34df"}[chunkId] + ".js";
};